export const ENUM = {
  STORETYPES: 'storeTypes'
};

export const ADDITIONAL_HEADERS_TIMEOUT = 2000; // In milliseconds
